import { Card } from "react-bootstrap";
import { formatVND, formatMoney } from "../utils/moneyFormat";

const cardStyle = { boxShadow: "0 2px 8px rgba(0,0,0,0.1)" };

const ReportSummaryCard = ({
  title,
  value,
  color = "#0d6efd",
  icon: Icon,
  loading = false,
  format = "money",
  subtitle,
  onClick,
  active = false,
  delta,
  deltaLabel,
  invertDelta = false,
  compact = false,
}) => {
  let display = "…";
  if (!loading) {
    if (format === "number") {
      display = formatMoney(value);
    } else if (format === "percent") {
      display = `${Number(value || 0).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      })}%`;
    } else {
      display = formatVND(value);
    }
  }

  const hasDelta = !loading && delta != null && Number.isFinite(Number(delta));
  const deltaNum = hasDelta ? Number(delta) : 0;
  const deltaUp = deltaNum > 0;
  const deltaFlat = deltaNum === 0;
  // Với chi phí, tăng là xấu (đỏ), giảm là tốt (xanh).
  const deltaGood = deltaFlat ? null : invertDelta ? !deltaUp : deltaUp;
  const deltaColor = deltaGood == null ? "#6c757d" : deltaGood ? "#198754" : "#dc3545";
  const deltaArrow = deltaFlat ? "→" : deltaUp ? "▲" : "▼";
  const deltaText = `${deltaArrow} ${Math.abs(deltaNum).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  })}%`;

  const clickable = typeof onClick === "function";
  const handleKeyDown = (e) => {
    if (!clickable) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick(e);
    }
  };

  const iconSize = compact ? 32 : 42;
  const iconRadius = compact ? 8 : 10;
  const iconFont = compact ? "0.85rem" : "1rem";

  return (
    <Card
      className={`h-100${compact ? " acc-kpi-compact" : ""}`}
      onClick={clickable ? onClick : undefined}
      onKeyDown={handleKeyDown}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      aria-pressed={clickable ? active : undefined}
      style={{
        ...cardStyle,
        borderLeft: `4px solid ${color}`,
        opacity: loading ? 0.55 : 1,
        cursor: clickable ? "pointer" : "default",
        outline: active ? "2px solid #0d6efd" : "none",
        outlineOffset: active ? "1px" : 0,
        transition: "outline 0.12s ease, box-shadow 0.12s ease",
      }}
    >
      <Card.Body className={compact ? "py-2 px-2" : "py-3"}>
        <div className={`d-flex align-items-center ${compact ? "gap-2" : "gap-3"}`}>
          {Icon && (
            <div
              style={{
                width: iconSize,
                height: iconSize,
                borderRadius: iconRadius,
                background: `${color}18`,
                color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: iconFont,
                flexShrink: 0,
              }}
            >
              <Icon />
            </div>
          )}
          <div className="min-w-0 flex-grow-1">
            <div className="acc-kpi-title text-truncate" title={title}>{title}</div>
            <div className="acc-kpi-value text-truncate" style={{ color }} title={String(display)}>{display}</div>
            {hasDelta && (
              <div className="d-flex align-items-center gap-1 text-truncate acc-kpi-meta">
                <span className="fw-semibold" style={{ color: deltaColor }}>{deltaText}</span>
                {deltaLabel && <span className="text-muted">{deltaLabel}</span>}
              </div>
            )}
            {subtitle && (
              <div className="acc-kpi-meta text-muted text-truncate" title={subtitle}>
                {subtitle}
              </div>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ReportSummaryCard;
